/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierIssueType } from "./CarrierIssueType";
import {
  CarrierIssueTypeFromJSON,
  CarrierIssueTypeFromJSONTyped,
  CarrierIssueTypeToJSON,
  CarrierIssueTypeToJSONTyped,
} from "./CarrierIssueType";

/**
 *
 * @export
 * @interface OperationalIssue
 */
export interface OperationalIssue {
  /**
   *
   * @type {string}
   * @memberof OperationalIssue
   */
  shipmentId: string;
  /**
   *
   * @type {CarrierIssueType}
   * @memberof OperationalIssue
   */
  issueType: CarrierIssueType;
  /**
   * Pickup "City, State".
   * @type {string}
   * @memberof OperationalIssue
   */
  pickup: string;
  /**
   * Delivery "City, State".
   * @type {string}
   * @memberof OperationalIssue
   */
  delivery: string;
  /**
   * Business name at the pickup location.
   * @type {string}
   * @memberof OperationalIssue
   */
  pickupBusinessName?: string;
  /**
   * Business name at the delivery location.
   * @type {string}
   * @memberof OperationalIssue
   */
  deliveryBusinessName?: string;
  /**
   *
   * @type {string}
   * @memberof OperationalIssue
   */
  proNumber?: string;
  /**
   *
   * @type {string}
   * @memberof OperationalIssue
   */
  billOfLadingNumber?: string;
  /**
   * Free-text task title, when the operations team set one.
   * @type {string}
   * @memberof OperationalIssue
   */
  title?: string;
  /**
   * ISO-8601 instant the issue was opened (the frontend renders it as a
   * relative-age badge). Omitted for customs holds.
   *
   * @type {string}
   * @memberof OperationalIssue
   */
  openedAt?: string;
}

/**
 * Check if a given object implements the OperationalIssue interface.
 */
export function instanceOfOperationalIssue(
  value: object,
): value is OperationalIssue {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("issueType" in value) || value["issueType"] === undefined) return false;
  if (!("pickup" in value) || value["pickup"] === undefined) return false;
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  return true;
}

export function OperationalIssueFromJSON(json: any): OperationalIssue {
  return OperationalIssueFromJSONTyped(json, false);
}

export function OperationalIssueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationalIssue {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    issueType: CarrierIssueTypeFromJSON(json["issueType"]),
    pickup: json["pickup"],
    delivery: json["delivery"],
    pickupBusinessName:
      json["pickupBusinessName"] == null
        ? undefined
        : json["pickupBusinessName"],
    deliveryBusinessName:
      json["deliveryBusinessName"] == null
        ? undefined
        : json["deliveryBusinessName"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    title: json["title"] == null ? undefined : json["title"],
    openedAt: json["openedAt"] == null ? undefined : json["openedAt"],
  };
}

export function OperationalIssueToJSON(json: any): OperationalIssue {
  return OperationalIssueToJSONTyped(json, false);
}

export function OperationalIssueToJSONTyped(
  value?: OperationalIssue | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    issueType: CarrierIssueTypeToJSON(value["issueType"]),
    pickup: value["pickup"],
    delivery: value["delivery"],
    pickupBusinessName: value["pickupBusinessName"],
    deliveryBusinessName: value["deliveryBusinessName"],
    proNumber: value["proNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    title: value["title"],
    openedAt: value["openedAt"],
  };
}
